import React from 'react'
import {
  useFieldArray,
  Control,
  UseFormSetValue,
  UseFormGetValues,
} from 'react-hook-form'
import { Button, Grid, Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { type ContactInfo } from 'types'
import { FormValues } from '..'
import Partner from './Partner'

interface Props {
  control: Control<FormValues>
  setValue: UseFormSetValue<FormValues>
  getValues: UseFormGetValues<FormValues>
}

const Partners = (props: Props) => {
  const { t } = useTranslation()
  const { control, setValue, getValues } = props

  const { fields, remove, append } = useFieldArray({
    control,
    name: `partners`,
    keyName: 'partnerId',
  })

  const handleAdd = () => {
    append({
      id: null,
      locale: 'el',
      email: '',
      landLineNumber: '',
      mobileNumber: '',
      contactName: '',
      description: '',
    } as ContactInfo)
  }

  return (
    <Box sx={{ my: 1 }}>
      <Button
        size="small"
        color="linkedin"
        variant="contained"
        onClick={handleAdd}
      >
        {t('dashboard.pages.createAgent.partners.addButton')}
      </Button>
      <Grid
        container
        spacing={2}
        justifyContent="flex-start"
        alignItems="center"
        sx={{ my: 2 }}
      >
        {fields.map((item, index) => {
          return (
            <Grid item xs={12} md={6} key={item.partnerId}>
              <Partner
                nestIndex={index}
                remove={remove}
                control={control}
                setValue={setValue}
                getValues={getValues}
              />
            </Grid>
          )
        })}
      </Grid>
    </Box>
  )
}

export default Partners
